export enum ENotificationType {
  Debug = 0,
  Info = 1,
  Warning = 2,
  Error = 3,
  Success = 4,
}
